import React from 'react';
import { SHIFT_KINDS } from '../utils';

const Legend = ({ counts = {}, active = [], onToggle, workOnly = false }) => (
    <div className="pc-sched-leg">
        {(workOnly ? SHIFT_KINDS.filter((kind) => kind.work) : SHIFT_KINDS).map((kind) => {
            const isOn = active.includes(kind.key);
            return (
                <button
                    key={kind.key}
                    type="button"
                    className={`pc-sched-lf${isOn ? ' on' : ''}`}
                    onClick={() => onToggle && onToggle(kind.key)}
                >
                    <i style={{ background: kind.color }} />
                    {kind.n}
                    <span className="n">{counts[kind.key] || 0}</span>
                </button>
            );
        })}
    </div>
);

export default Legend;
